import { mergeStyles } from '@fluentui/react';

const textFieldStyle = mergeStyles({
  width: '100%',
  height: '44px important!',
  background: '#ffffff',
  fontSize: '14px',
  '.ms-TextField-fieldGroup': {
    minHeight: '0px'
  },
  '#sendbox': {
    overflow:"auto",
    fontSize: '14px',
    height: '44px !important',
  },
  '#sendbox::-webkit-input-placeholder': {
    fontSize: '14px'
  }
});

const TextFieldStyleProps = {
  background: '#ffffff',
  wrapper: {
    background: '#ffffff'
  },
  fieldGroup: {
    minHeightL: '0px',
    background: '#ffffff'
  }
};
const sendBoxStyle = mergeStyles({
  border: '0rem', // 0px
  color: 'black',
  backgroundColor: '#FFFFFF',
  fontWeight: 400,
  fontSize: '1rem', // 16px
  width: '100%',
  height: '44px',
  minheight: '44px',
  '::-webkit-input-placeholder': {
    fontSize: '1rem'
  },
  '::-moz-placeholder': {
    fontSize: '1rem'
  },
  ':-moz-placeholder': {
    fontSize: '1rem'
  },

});

const sendIconStyle = mergeStyles({
  color: 'grey',
  cursor: 'pointer',
  ':hover': {
    transform: 'scale(1.2)'
  },
  position: 'absolute',
  right: '26px'
});
const PromptText = mergeStyles({
  borderRadius: '3px',
  bottom: '87px',
  paddingLeft: '8px',
  right: '4%',
  fontSize: '0.875rem', // 14px
  position: 'absolute',
  color: '#C4314B'
});
const sendBox = mergeStyles({
  padding: '0px 4%',
});

const IconPStyle = mergeStyles({
  paddingRight: '10px',
  boxSizing: 'border-box',
  fontSize: '16px'
});
const scrollToBottom = mergeStyles({
  marginTop:"-40px",
  right: '18%',
  marginRight:' 6px',
  lineHeight: '22px',
  position: 'absolute',
  background: '#FFFFFF',
  minWidth: '88px',
  padding:"0px 4px",
  height: '26px',
  border: '1px solid #D1D1D1',
  borderRadius: '4px',
  textAlign: 'center',
  cursor: 'pointer',
  fontWeight: 600,
  fontSize: '12px',
  color: '#242424'
});

const TransferCard = mergeStyles({
  minHeight: '105px',
  width: '60%',
  padding: '13px  26px',
  backgroundColor: 'rgb(229, 229, 241)',
  borderRadius: '3px'
});
const boxStyle = mergeStyles({
  padding: '12px 16%',
  boxSizing: 'border-box',
  position:"relative",
  background: '#F5F5F5',
  borderTop: '1px solid #F0F0F0',
  boxShadow: '0px 1.2px 3.6px rgba(0, 0, 0, 0.03), 0px 6.4px 14.4px rgba(0, 0, 0, 0.07)'
});

export {
  textFieldStyle,
  sendBoxStyle,
  sendIconStyle,
  TextFieldStyleProps,
  sendBox,
  IconPStyle,
  scrollToBottom,
  TransferCard,
  PromptText,
  boxStyle
};
